import { useAtom } from 'jotai';
import { domain } from 'modules/data';
import { useCallback, useState } from 'react';

import {
    schedulerIncludeEndYearState,
    schedulerIncludeStartYearState,
    schedulerRadioCheckedState,
} from './SchedulerYear.states';

export const useSchedulerIncludeYearEdit = () => {
    const [schedulerIncludeStartYear, setSchedulerIncludeStartYear] = useAtom(schedulerIncludeStartYearState);
    const [schedulerIncludeEndYear, setSchedulerIncludeEndYear] = useAtom(schedulerIncludeEndYearState);

    const handleIncludeStartYearChange = useCallback(
        (value: number) => {
            setSchedulerIncludeStartYear(value);
        },
        [setSchedulerIncludeStartYear]
    );

    const handleIncludeEndYearChange = useCallback(
        (value: number) => {
            setSchedulerIncludeEndYear(value);
        },
        [setSchedulerIncludeEndYear]
    );

    return {
        schedulerIncludeStartYear,
        schedulerIncludeEndYear,
        handleIncludeStartYearChange,
        handleIncludeEndYearChange,
    };
};

export const useSchedulerRadioChecked = () => {
    const [schedulerRadioChecked, setSchedulerRadioChecked] = useAtom(schedulerRadioCheckedState);

    const handleRadioCheckedChange = useCallback(
        (value: domain.ScheduleYearType) => {
            setSchedulerRadioChecked(value);
        },
        [setSchedulerRadioChecked]
    );

    return {
        schedulerRadioChecked,
        handleRadioCheckedChange,
    };
};

export const useSchedulerExcludedYears = () => {
    const [schedulerExcludedYears, setSchedulerExcludedYears] = useState<string[]>([]);

    const handleExcludeYearChange = useCallback(
        (value: string[]) => {
            setSchedulerExcludedYears(value);
        },
        [setSchedulerExcludedYears]
    );

    return {
        schedulerExcludedYears,
        handleExcludeYearChange,
    };
};
